"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineMessages = void 0;
/**
 * Define intl messages for a container with a namespace applied to each message key to create a unique id.
 *
 * Can also specify and enum if the messages must have a definition for each enum type
 *
 * ```ts
 *  enum RequestAction {
 *    Access = 'ACCESS',
 *    Erasure = 'ERASURE',
 *  }
 *  const messages = defineMessages<RequestAction>('my-unique-namespace', {
 *     ACCESS: {
 *       defaultMessages: 'Access Request!'
 *     },
 *     ERASURE: {
 *      defaultMessages: 'Erasure Request!'
 *    },
 *  })
 *
 * ```
 *
 * @param namespace - The namespace to use for ids
 * @param messages - The message definitions
 * @returns The intl message definition creator
 */
function defineMessages(namespace, messages) {
    return Object.keys(messages).reduce((acc, key) => Object.assign(acc, {
        [key]: {
            ...messages[key],
            id: `${namespace}.${key}`,
        },
    }), {});
}
exports.defineMessages = defineMessages;
//# sourceMappingURL=defineMessages.js.map